import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_ID;

/**
 * Google Analytics 4 wiring. No-op when REACT_APP_GA_ID is not set.
 * Loads gtag.js once and emits a page_view on every route change.
 */
export default function Analytics() {
    const location = useLocation();

    useEffect(() => {
        if (!GA_ID) return;
        if (window.__rj_ga_loaded) return;
        window.__rj_ga_loaded = true;
        const s = document.createElement("script");
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
        document.head.appendChild(s);
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        window.gtag = gtag;
        gtag("js", new Date());
        gtag("config", GA_ID, { send_page_view: false });
    }, []);

    useEffect(() => {
        if (!GA_ID || !window.gtag) return;
        window.gtag("event", "page_view", {
            page_path: location.pathname + location.search,
            page_location: window.location.href,
            page_title: document.title,
        });
    }, [location.pathname, location.search]);

    return null;
}
